import React from "react";
import moment from "moment";
import Select from "react-select";
import * as colors from "material-ui/styles/colors";

import connectToStores from "alt-utils/lib/connectToStores";
import UserStore from "../stores/UserStore";
import BillingUtil from "../utils/BillingUtil";
import { formatPrice, capitalize, unSnakeCase } from "../util.js";

import TableRefreshIndicator from "./partials/table-refresh-indicator.jsx";
import GenericAnalyticsTable from "./partials/generic-analytics-table.jsx";

import qs from "query-string";
const parsedQueryString = qs.parse(window.location.search);

const BILLING_TIMEZONE = "America/Chicago";

import WorkingIndicator from "./partials/working-indicator.jsx";

class GodInvoicingHub extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hubData: null,
      selectedMonth:
        parsedQueryString.month ||
        moment().tz(BILLING_TIMEZONE).format("MM-YYYY")
    };
  }

  static getStores() {
    return [UserStore];
  }

  static getPropsFromStores() {
    return UserStore.getState();
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  componentDidMount() {}

  _generateMonths() {
    let curr = moment("02-2021", "MM-YYYY") // first month of ledger billing = Feb 2021
      .tz(BILLING_TIMEZONE)
      .startOf("month");
    let end = moment().tz(BILLING_TIMEZONE).startOf("month");

    let months = [];

    while (curr) {
      if (curr <= end) {
        months.push({
          value: curr.format("MM-YYYY"),
          label:
            curr.diff(end) === 0
              ? moment().tz(BILLING_TIMEZONE).format("MMMM [1]–D, YYYY")
              : curr.format("MMMM YYYY"),
          _end: moment(curr).endOf("month")
        });
        curr.add(1, "month");
      } else {
        curr = null;
      }
    }

    return months.reverse();
  }

  _loadHub({ quiet } = {}) {
    let selectingMonth = this.state.selectedMonth;

    this.setState(
      Object.assign({ loading: true }, !quiet && { hubData: null })
    );

    BillingUtil.fetchInvoicingHub(UserStore.getState().apiKey, {
      month: selectingMonth
    })
      .then(data => {
        if (this.state.selectedMonth === selectingMonth) {
          this.setState({
            loading: false,
            hubData: data
          });
        }
      })
      .catch(e => window.alert(e.message));
  }

  componentWillReceiveProps(newProps) {
    if (!this.state.loading && !this.state.hubData) {
      this._loadHub();
    }
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  render() {
    const months = this._generateMonths();

    if (!this.props.apiKey) {
      return <WorkingIndicator fullPage={true} />;
    }

    return (
      <div>
        <h2 style={{ display: "flex", alignItems: "center" }}>
          <span style={{ whiteSpace: "nowrap" }}>God Invoicing Hub for</span>
          <div
            style={{
              display: "inline-block",
              width: 250,
              marginLeft: 10
            }}
          >
            <Select
              clearable={false}
              value={this.state.selectedMonth}
              options={months}
              onChange={e =>
                this.setState({ selectedMonth: e.value }, () => {
                  this.context.router.replace(
                    `/god/invoicing_hub?month=${e.value}`
                  );
                  this._loadHub();
                })
              }
            />
          </div>
        </h2>
        {this.state.hubData ? (
          <div>
            <TableRefreshIndicator
              isRefreshing={this.state.loading}
              onRefresh={() => this._loadHub({ quiet: true })}
              style={{ marginTop: -45 }}
            />
            <GenericAnalyticsTable
              csvLabel="eventive-invoice"
              csvLabelDetail={this.state.selectedMonth}
              noSort
              noDownload
              data={this.state.hubData.users.map((user, i) => {
                return {
                  index: i + 1,
                  organization: user.organization,
                  net: {
                    value: user.net,
                    label: formatPrice(user.net, {
                      currency: user.currency,
                      accounting: true
                    })
                  },
                  invoice: {
                    value: "",
                    label:
                      user.invoice && user.invoice.stripe_invoice_id ? (
                        <a
                          href={`https://dashboard.stripe.com/invoices/${user.invoice.stripe_invoice_id}/edit`}
                          target="_blank"
                          style={{ color: "#fff" }}
                        >
                          {moment(user.invoice.finalized_at).format(
                            "MMM D h:mm a"
                          )}
                        </a>
                      ) : (
                        "NOT YET"
                      ),
                    itemStyle: {
                      backgroundColor:
                        user.invoice && user.invoice.stripe_invoice_id
                          ? colors.green600
                          : colors.red800,
                      color: "#fff",
                      borderBottom: "1px solid #fff",
                      fontWeight: "bold"
                    }
                  },
                  actions: {
                    value: "",
                    label: (
                      <span>
                        <a
                          target="_blank"
                          href={`/billing?month=${this.state.selectedMonth}&_god_become_user=${user.id}`}
                        >
                          View billing
                        </a>
                      </span>
                    )
                  }
                };
              })}
              columns={[
                { label: "Rank", value: "index" },
                { label: "Organization", value: "organization" },
                { label: "Net", value: "net" },
                { label: "Invoiced", value: "invoice" },
                { label: "Actions", value: "actions" }
              ]}
            />
          </div>
        ) : (
          <div>
            <WorkingIndicator fullPage={true} />
          </div>
        )}
      </div>
    );
  }
}

export default connectToStores(GodInvoicingHub);



// WEBPACK FOOTER //
// ./src/app/components/god-invoicing-hub.jsx